module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/image-placeholder-0d7c8f52.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/image-placeholder.svg
// module id = ./app/web/src/assets/image-placeholder.svg
// module chunks = 0